import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  events: [],
  message: null,
  error: null,
};

export const eventReducer = createReducer(initialState, (builder) => {
  builder
    // Get all events for a shop
    .addCase("getAllEventsShopRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getAllEventsShopSuccess", (state, action) => {
      state.isLoading = false;
      state.events = action.payload;
    })
    .addCase("getAllEventsShopFailed", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Get all events (public)
    .addCase("getAllEventsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getAllEventsSuccess", (state, action) => {
      state.isLoading = false;
      state.events = action.payload;
    })
    .addCase("getAllEventsFailed", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Delete event
    .addCase("deleteEventRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("deleteEventSuccess", (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
    })
    .addCase("deleteEventFailed", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Create event
    .addCase("createEventRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("createEventSuccess", (state, action) => {
      state.isLoading = false;
      state.events = [...state.events, action.payload];
      state.message = "Event created successfully!";
    })
    .addCase("createEventFailed", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Clear messages
    .addCase("clearMessages", (state) => {
      state.message = null;
      state.error = null;
    });
});
